import Button from '../../../../components/Button';
import { useGiftForm } from '../../../../components/GiftFormContext';
import TextInput, { ErrorMessage } from '../../../../components/Inputs/Text';
import AddressAutocomplete from '../../../../components/Inputs/AddressAutocomplete';
import { useEffect, useState } from 'react';
import {
  EVENT_GIFT_FLOW_SHIPPING_ADDRESS_CHANGED,
  EVENT_GIFT_FLOW_SHIPPING_DETAILS_COMPLETED,
  EVENT_GIFT_FLOW_SHIPPING_RECIPIENT_NAME_CHANGED,
  sendEvent,
} from '../../../../common/analytics';

const ShippingAddress = ({
  onContinue,
  buttonLabel = 'Continue',
  isModal,
  currentStep,
}) => {
  const {
    recipientName,
    setValue,
    addressLine1,
    addressLine2,
    city,
    state,
    postalCode,
    country,
    delivery,
  } = useGiftForm();

  const [addressValue, setAddressValue] = useState('');

  // Auto-advance if delivery is not 'mail'
  useEffect(() => {
    if (delivery !== 'mail' && onContinue) {
      onContinue();
    }
  }, [delivery, onContinue]);

  const handleAddressChange = (e) => {
    const value = e.target.value;
    setAddressValue(value);
    sendEvent(EVENT_GIFT_FLOW_SHIPPING_ADDRESS_CHANGED, {
      address: value,
    });
  };

  const validForm =
    recipientName &&
    addressLine1 &&
    city &&
    state &&
    postalCode &&
    country &&
    country === 'United States';
  return (
    <>
      <TextInput
        label='Recipient Name'
        value={recipientName || ''}
        onChange={(e) => {
          setValue('recipientName', e.target.value);
          sendEvent(EVENT_GIFT_FLOW_SHIPPING_RECIPIENT_NAME_CHANGED, {
            recipientName: e.target.value,
          });
        }}
      />
      <AddressAutocomplete
        label='Shipping Address'
        placeholder='Start typing an address...'
        value={addressValue}
        onChange={handleAddressChange}
        addressLine1={addressLine1}
        addressLine2={addressLine2}
        city={city}
        state={state}
        postalCode={postalCode}
        country={country}
        setAddressLine1={(value) => setValue('addressLine1', value)}
        setAddressLine2={(value) => setValue('addressLine2', value)}
        setFormattedAddress={(value) => setValue('formattedAddress', value)}
        setCity={(value) => setValue('city', value)}
        setState={(value) => setValue('state', value)}
        setPostalCode={(value) => setValue('postalCode', value)}
        setCountry={(value) => setValue('country', value)}
      />
      {country && country !== 'United States' && (
        <ErrorMessage>
          We currently only support shipping to the United States.
        </ErrorMessage>
      )}
      <Button
        fullWidth
        clickAnimation="bouncy"
        onClick={() => {
          onContinue();
          sendEvent(EVENT_GIFT_FLOW_SHIPPING_DETAILS_COMPLETED);
        }}
        disabled={!validForm}
      >
        {buttonLabel}
      </Button>
    </>
  );
};

export default ShippingAddress;
